export const GPU_TELEMETRY_ENVIRONMENTS = ['dev', 'prod'] as const
export type GpuEnvironment = (typeof GPU_TELEMETRY_ENVIRONMENTS)[number]

const GPU_ENVIRONMENT_BY_DEPLOYMENT: Readonly<Record<string, GpuEnvironment>> = {
  dev: 'dev',
  development: 'dev',
  test: 'dev',
  beta: 'prod',
  prod: 'prod',
  production: 'prod',
}

export function gpuTelemetryEnvironmentForDeployment(deploymentEnvironment: string): GpuEnvironment {
  const normalized = deploymentEnvironment.trim().toLowerCase()
  const environment = GPU_ENVIRONMENT_BY_DEPLOYMENT[normalized]
  if (!environment) {
    throw new Error(`Unsupported analytics deployment environment: ${deploymentEnvironment}`)
  }
  return environment
}
